import { useCallback, useEffect } from "react";
import type React from "react";

export const useClickOutside = (
  ref: React.RefObject<HTMLElement | null>,
  onClick: () => void,
  isActive = true,
  stopPropagation = false,
) => {
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        if (stopPropagation) {
          event.stopPropagation();
        }
        onClick();
      }
    },
    [onClick, ref, stopPropagation],
  );

  useEffect(() => {
    if (isActive) {
      document.addEventListener("mousedown", handleClickOutside, {
        capture: true,
      });
      return () => {
        document.removeEventListener("mousedown", handleClickOutside, {
          capture: true,
        });
      };
    }
  }, [handleClickOutside, isActive]);
};
